import * as React from 'react';

const SofortPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#sofort-payment-rebranding_svg__clip0_101_991)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M164.264 93H17.988l9.75-58h146.274l-9.748 58z"
                fill="#2E3235"
            />
            <path
                d="M45.125 60.116c0 .596.506.894 2.728 2.01 2.838 1.44 4.634 2.929 4.634 5.635 0 3.325-2.787 5.905-7.954 5.905-3.32 0-5.514-1.117-7.042-2.208l.857-5.162C39.82 67.66 42.31 69 44.454 69c1.232 0 2.167-.421 2.167-1.166 0-.695-.56-1.043-2.783-2.185-2.49-1.265-4.578-2.705-4.578-5.46 0-3.2 2.865-5.856 7.87-5.856 2.519 0 5.25.866 8.216 2.523a12.137 12.137 0 00-2.467 4.283C50.788 59.157 48.651 59 47.237 59c-1.231 0-2.112.372-2.112 1.116z"
                fill="#E5E5E0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.57 64.874c0-5.738 4.968-10.54 11.532-10.54 5.58 0 9.67 3.448 9.67 8.644 0 5.738-4.967 10.69-11.531 10.69-5.58 0-9.67-3.597-9.67-8.794zm5.818-.246c0 2.537 1.754 4.162 4.252 4.162 3.134 0 5.315-2.56 5.315-5.368 0-2.537-1.755-4.237-4.252-4.237-3.134 0-5.315 2.636-5.315 5.443zM94.122 64.874c0-5.738 4.968-10.54 11.531-10.54 5.58 0 9.674 3.448 9.674 8.644 0 5.738-4.971 10.69-11.535 10.69-5.58 0-9.67-3.597-9.67-8.794zm5.82-.246c0 2.537 1.752 4.162 4.249 4.162 3.138 0 5.315-2.56 5.315-5.368 0-2.537-1.754-4.237-4.252-4.237-3.134 0-5.311 2.636-5.311 5.443zM134.641 60.439c0-3.475-2.728-5.708-7.654-5.708h-6.963l-3.051 18.54h5.862l.963-5.833h.268l3.107 5.832h6.718l-4.31-6.478c3.161-1.092 5.06-3.45 5.06-6.353zm-9.343 3.053h-.857l.644-3.872h.777c1.82 0 2.783.546 2.783 1.737 0 1.415-1.366 2.135-3.347 2.135z"
                fill="#E5E5E0"
            />
            <path
                d="M91.198 62.87h-6.864l.537-3.25h7.362c.953-1.956 2.429-3.628 4.27-4.89H84.454c-2.673 0-4.944 1.81-5.346 4.258L76.756 73.27h5.865l.963-5.832h6.963l.503-3.17c.024-.474.072-.94.148-1.397zM137.507 59.62c-.207-2.026-1.173-3.695-2.739-4.89h19.743l-.805 4.89h-5.432l-2.253 13.65h-5.862l2.25-13.65h-4.902z"
                fill="#E5E5E0"
            />
        </g>
        <defs>
            <clipPath id="sofort-payment-rebranding_svg__clip0_101_991">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

SofortPaymentRebrandingSvg.displayName = 'SofortPaymentRebrandingSvg';
export default SofortPaymentRebrandingSvg;
